import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const useUserCurrency = () => {
  const [userCurrency, setUserCurrency] = useState("");
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);

  useEffect(() => {
    const isOrangeMode =
      userInfo.user?.price_mode === PriceModes.ORANGE &&
      userInfo.currencyConversion();
    const enableInWhiteMode =
      userInfo.currencyConversion() &&
      userInfo.user?.feature_settings?.enable_currency_conversion_in_white_mode;
    const customCurrency =
      userInfo.user?.feature_settings?.custom_currency_symbol && isCustomApp;
    setUserCurrency(
      isOrangeMode || enableInWhiteMode || customCurrency
        ? userInfo.user.currency_symbol
        : t("global.text.currencySymbol")
    );
  }, [userInfo.user?.price_mode, userInfo.user?.currency_symbol, t]);

  return userCurrency;
};
